// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const LOCAL_ORIGIN = 'http://localhost:4200';

export const environment = {
  production: false,
  envName: 'local',
  hostname: 'localhost',
  baseApiUrl: 'https://api.dev.cert.toyota.com',
  projectApiPath: '/dev_createproject/',
  dashboardApiPath: '/dev_dashboard/',
  superAdminApiPath: '/dev_superadmin/',
  userApiPath: '/dev_user/',
  redirectUrl: '',
  redirectUri: LOCAL_ORIGIN,
  redirect_uri: LOCAL_ORIGIN,
  proxy: '/{proxy+}',
  postLogoutRedirectUri: LOCAL_ORIGIN,
  baseLoginUrl: `https://login.microsoftonline.com/tmnatest.onmicrosoft.com/oauth2/v2.0/authorize?client_id=13670975-bfc1-4c0f-b776-aaf155481755&response_type=code&redirect_uri=${LOCAL_ORIGIN}&response_mode=query&scope=openid%20profile%20email%20offline_access%20https%3A%2F%2Fgraph.microsoft.com%2FUser.Read&claims=%7B%22access_token%22%3A%7B%22capolids%22%3A%7B%22essential%22%3Atrue%2C%22values%22%3A%5B%222d17fe5e-e439-4910-a5dd-6efa578c163f%22%5D%7D%7D%7D`,
  tokenURL: 'https://login.microsoftonline.com/tmnatest.onmicrosoft.com/oauth2/v2.0/token',
  logoutUrl: 'https://login.microsoftonline.com/common/oauth2/logout',
  grantType: 'authorization_code',
  clientId: '13670975-bfc1-4c0f-b776-aaf155481755',
  redirectURI: LOCAL_ORIGIN,
  scopes: ['user.read', 'email', 'profile'],
  authority: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/',
  graphApiUrl: 'https://graph.microsoft.com/v1.0'
};

